// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cartTotalPrice[data-v-1819fcbc]{align-items:center;border:1px solid #e6e7eb;border-radius:11px;color:#010d35;display:flex;font-size:20px;font-weight:600;justify-content:space-between;line-height:25px;padding:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
